import { render, staticRenderFns } from "./FollowAmountTooltip.vue?vue&type=template&id=d06a869e"
import script from "./FollowAmountTooltip.vue?vue&type=script&lang=js"
export * from "./FollowAmountTooltip.vue?vue&type=script&lang=js"
import style0 from "./FollowAmountTooltip.vue?vue&type=style&index=0&id=d06a869e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports